import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/XMP/getting-started/xmp.md";
import * as React from 'react';
export default {
  Content,
  React
};